import {Button, Dialog, DialogActions, DialogContent, DialogTitle, SxProps} from '@mui/material';
import {FC} from 'react';
import {useRecoilState} from 'recoil';
import {managerListModalAtom} from '../store/manager-list-modal.store';
import {ManagerList} from './manager-list';

const STYLES = {
  content: {
    height: 600,
  },
} as const satisfies Record<string, SxProps>;

export const MangerListModal: FC = () => {
  const [isOpen, setIsOpen] = useRecoilState(managerListModalAtom);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} scroll="paper" maxWidth="md" fullWidth>
      <DialogTitle>Список менеджеров</DialogTitle>
      <DialogContent dividers sx={STYLES.content}>
        <ManagerList />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Закрыть</Button>
      </DialogActions>
    </Dialog>
  );
};
